/* eslint-disable */
/* tslint:disable */
/*
 * -------------------- /!\ WARNING /!\ --------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API  ##
 * ## DO NOT EDIT MANUALLY                                ##
 * ## YOUR CHANGES WILL BE OVERWRITTEN                    ##
 * -------------------- /!\ WARNING /!\ --------------------
 */

export type WayfinderPatientAppointmentResponseDto = object;

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    /** @format int32 */
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    [key: string]: any;
}

export interface WayfinderPatientAppointmentRequestDto {
    /**
     * Organisation ODS Code
     * @minLength 1
     */
    odsCode: string;
    /** The type of request, cancel vs rebook */
    requestType: PatientAppointmentRequestType;
    /**
     * The patient nhs number
     * @minLength 1
     */
    nhsNumber: string;
    /**
     * The patient date of birth in ISO format e.g. 2001-01-30
     * @format date
     * @minLength 1
     */
    dateOfBirth: string;
    /**
     * The time of the appointment in ISO format e.g. 2024-11-01T09:26:01Z
     * @format date-time
     * @minLength 1
     */
    appointmentTime: string;
    /**
     * Clinic code of the appointment
     * @minLength 1
     * @maxLength 100
     */
    clinicCode: string;
    /**
     * The service offering the appointment
     * @minLength 0
     * @maxLength 100
     */
    serviceName?: string | null;
    /**
     * The location of the service/appointment
     * @minLength 0
     * @maxLength 150
     */
    serviceLocation?: string | null;
    /** The clinician(s) responsible for the appointment */
    clinicians?: string[] | null;
    /**
     * The type of appointment, e.g. Face to Face vs Telephone
     * @minLength 0
     * @maxLength 50
     */
    appointmentType?: string | null;
    /**
     * The reason provided by the patient for the change
     * @minLength 0
     * @maxLength 3200
     */
    patientChangeReason?: string | null;
}

export enum PatientAppointmentRequestType {
    Reschedule = "Reschedule",
    Cancel = "Cancel",
}

export interface AppointmentBookWork {
    /** @format int32 */
    organisationId?: number | null;
    requestId?: string | null;
    /** @format date-time */
    from?: string | null;
    /** @format date-time */
    to?: string | null;
    /** @format date-time */
    now?: string | null;
}

export interface AppointmentBookWorkResult {
    /** @format int32 */
    organisationId: number;
    /** @minLength 1 */
    requestId: string;
    success: boolean;
    /** @format date-time */
    from?: string | null;
    /** @format date-time */
    to?: string | null;
    appointments?: Appointment[] | null;
    sourceSystemType?: PrincipalSystemType | null;
}

export interface Appointment {
    /** @minLength 1 */
    id: string;
    /** @format int32 */
    emisSessionId?: number | null;
    /** @minLength 1 */
    slotType: string;
    siteName?: string | null;
    /**
     * @format date-time
     * @minLength 1
     */
    startTime: string;
    bookedPatientDemographics?: PatientDemographicDetails | null;
    structuredClinicians: Clinician[];
}

export type PatientDemographicDetails = PatientExternalIdentityDto & {
    demographicMobileNumber?: string | null;
    names?: PatientName[] | null;
    /** @format date-time */
    dateOfBirth?: string | null;
    gender?: string | null;
};

export interface PatientName {
    use: PatientNameUse;
    prefix?: string[] | null;
    given?: string[] | null;
    family?: string[] | null;
}

export enum PatientNameUse {
    None = 0,
    Usual = 1,
    Official = 2,
    Temp = 3,
    Nickname = 4,
    Anonymous = 5,
    Old = 6,
    Maiden = 7,
}

export interface PatientExternalIdentityDto {
    patientExternalIds?: PatientExternalIdDto[] | null;
}

export interface PatientExternalIdDto {
    type: IdType;
    /** @minLength 1 */
    value: string;
}

export enum IdType {
    None = 0,
    NhsNumber = 1,
    Emis = 2,
    Dummy = 3,
    SystmOne = 4,
    Vision = 5,
    Hospital = 6,
    ChiNumber = 7,
    UnmatchedNhsNumber = 8,
}

export interface Clinician {
    userId?: string | null;
    displayName?: string | null;
}

export enum PrincipalSystemType {
    None = 0,
    Emis = 1,
    SystmOne = 2,
    Vision = 3,
    Pas = 4,
}

export interface AppointmentCancelWork {
    /** @format int32 */
    organisationId?: number | null;
    requestId?: string | null;
    appointmentId?: string | null;
    patient: PatientExternalIdentityDto;
}

export interface AppointmentCancelWorkResult {
    /** @format int32 */
    accuRxOrgId: number;
    /** @minLength 1 */
    requestId: string;
    succeeded: boolean;
}

export interface AppointmentChangeRequestResponse {
    appointmentChangeRequests: AppointmentChangeRequest[];
}

export interface AppointmentChangeRequest {
    externalIdDisplay: PatientExternalIdDto;
    /** @format date-time */
    appointmentStartTime: string;
    patientName: string;
    /** @format date-time */
    appointmentChangedAt: string;
    clinicianName?: string[] | null;
    slotType?: string | null;
    changeRequestType: AppointmentChangeRequestType;
    status: AppointmentChangeRequestStatus;
}

export enum AppointmentChangeRequestType {
    Cancel = "Cancel",
    Rebook = "Rebook",
}

export enum AppointmentChangeRequestStatus {
    Skipped = "Skipped",
    Succeeded = "Succeeded",
    Failed = "Failed",
}

export interface AppointmentReminderAuditResponse {
    appointmentReminderDeliveryReceipts: AppointmentReminderDeliveryReceipt[];
}

export interface AppointmentReminderDeliveryReceipt {
    id: string;
    externalIdDisplay: PatientExternalIdDto;
    status: string;
    patientName: string;
    appointmentStartTime: string;
    appointmentReminderItemType: ReminderItemType;
}

export enum ReminderItemType {
    WeekBeforeAppointmentReminder = "WeekBeforeAppointmentReminder",
    PreviousWorkingDayAppointmentReminder = "PreviousWorkingDayAppointmentReminder",
    PostAppointmentReminder = "PostAppointmentReminder",
    ThreePreviousWorkingDayAppointmentReminder = "ThreePreviousWorkingDayAppointmentReminder",
}

export interface AppointmentReminderConfigOptions {
    availableFilters: AppointmentReminderFilterAttribute[];
    supportedChanges: AppointmentSupportedChanges;
    changeDeadline: Deadline;
    defaultAdditionalReminders: DefaultAdditionalReminders;
    appointmentTypes: AppointmentTypeFilter[];
    siteNames: string[];
    slotTypes: string[];
}

export enum AppointmentReminderFilterAttribute {
    AppointmentTypes = "AppointmentTypes",
    ClinicCodes = "ClinicCodes",
    SiteNames = "SiteNames",
    SlotTypes = "SlotTypes",
}

export interface AppointmentSupportedChanges {
    cancellation: CancellationOption;
    rebooking: RebookingOption;
}

export enum CancellationOption {
    Manual = "Manual",
    Automatic = "Automatic",
}

export enum RebookingOption {
    NotSupported = "NotSupported",
    Manual = "Manual",
}

export enum Deadline {
    OneHour = "OneHour",
    OneWorkingDay = "OneWorkingDay",
    ThreeWorkingDays = "ThreeWorkingDays",
}

export interface DefaultAdditionalReminders {
    oneWeekReminderEnabled: boolean;
    threeWorkingDayReminderEnabled: boolean;
}

export enum AppointmentTypeFilter {
    FaceToFace = "FaceToFace",
    Telephone = "Telephone",
}

export type GetAppointmentRemindersResponse =
    BaseAppointmentRemindersResponse & {
        slotTypes: string[];
        siteNames: string[];
        appointmentTypes: AppointmentTypeFilterOption[];
    };

export interface AppointmentTypeFilterOption {
    value: AppointmentTypeFilter;
    description: string;
}

export interface BaseAppointmentRemindersResponse {
    appointmentReminders: AppointmentReminder[];
}

export interface AppointmentReminder {
    /** @format int32 */
    id: number;
    customMessageBody?: string | null;
    slotTypes: string[];
    siteNames: string[];
    oneWeekReminderEnabled: boolean;
    threeWorkingDayReminderEnabled: boolean;
    postAppointmentMessageEnabled: boolean;
    postAppointmentCustomMessage?: string | null;
    type: string;
    appointmentTypeFilters: AppointmentTypeFilter[];
    appointmentCancellationSupport: CancellationOption;
    appointmentRebookingSupport: RebookingOption;
    appointmentChangingDeadline: Deadline;
}

export interface CreateAppointmentReminderRequest {
    customMessageBody?: string | null;
    slotTypes: string[];
    siteNames: string[];
    oneWeekReminderEnabled?: boolean | null;
    threeWorkingDayReminderEnabled?: boolean | null;
    postAppointmentMessageEnabled?: boolean | null;
    postAppointmentCustomMessage?: string | null;
    type?: string | null;
    appointmentTypeFilters?: AppointmentTypeFilter[] | null;
    appointmentCancellationSupport: CancellationOption;
    appointmentRebookingSupport: RebookingOption;
    appointmentChangingDeadline: Deadline;
}

export type UpdateAppointmentReminderRequest =
    CreateAppointmentReminderRequest & {
        /** @format int32 */
        appointmentReminderId: number;
    };

export type AppointmentReminderWithIdDto = AppointmentReminderDto & {
    /** @format int32 */
    id: number;
};

export interface AppointmentReminderDto {
    templateType: ReminderTemplateType;
    /** @minItems 1 */
    slotTypeFilter: string[];
    siteNameFilter?: string[] | null;
    appointmentTypeFilter?: AppointmentType[] | null;
    customMessageBody?: string | null;
    oneWeekEnabled: boolean;
    threeWorkingDayEnabled: boolean;
    postAppointmentEnabled: boolean;
    postAppointmentMessageBody?: string | null;
    cancellation: CancellationOption;
    rebooking: RebookingOption;
    amendmentDeadline: Deadline;
}

export enum ReminderTemplateType {
    FaceToFace = "FaceToFace",
    Telephone = "Telephone",
}

export enum AppointmentType {
    FaceToFace = "FaceToFace",
    Telephone = "Telephone",
}

export interface BulkAppointmentImport {
    /** @format int32 */
    id: number;
    fileName?: string | null;
    /** @format int32 */
    appointmentsCount: number;
    createdByUserName?: string | null;
    /** @format date-time */
    uploadAt: string;
    status: BulkAppointmentImportStatus;
}

export enum BulkAppointmentImportStatus {
    InReview = 1,
    Processing = 2,
    Completed = 3,
    Failed = 4,
}

export interface BulkAppointmentUploadPatientFileResponse {
    isUploadSuccess: boolean;
    bulkAppointmentImportId?: string | null;
    bulkAppointmentItems?: BulkAppointmentUploadItem[] | null;
    validationErrors?: BulkAppointmentUploadValidationErrors | null;
}

export interface BulkAppointmentUploadItem {
    appointmentId?: string | null;
    /** @format date-time */
    appointmentStartDateTime: string;
    appointmentClinicCode: string;
    appointmentType: string;
    location?: string | null;
    /** @format date */
    dateOfBirth: string;
    practitioner?: string | null;
    patientNhsNumber: string;
}

export interface BulkAppointmentUploadValidationErrors {
    parsingErrors: BulkAppointmentUploadParsingError[];
    dataErrors: BulkAppointmentUploadDataError[];
    hasErrors: boolean;
}

export interface BulkAppointmentUploadParsingError {
    type: string;
    message: string;
}

export interface BulkAppointmentUploadDataError {
    type: string;
    rowNumbers: number[];
}

export interface AppointmentConfiguration {
    /** @format int32 */
    selfBookSchedulingWeeksIntoFuture: number;
    selfBookSchedulingIntoFutureEnabled: boolean;
    /** @format int32 */
    selfBookMaxAppointmentAvailabilityWeeks: number;
    selfBookCrossOrgBookableOrganisations: CrossOrgBookableOrganisation[];
}

export interface CrossOrgBookableOrganisation {
    name: string;
    odsCode: string;
}

export interface IntegratedClinicListResponse {
    /** @format date-time */
    lastUpdated?: string | null;
    /** @format date */
    startDate: string;
    /**
     * End date is inclusive
     * @format date
     */
    endDate: string;
    clinics: IntegratedClinicNoPiiResponse[];
}

export interface IntegratedClinicNoPiiResponse {
    name?: string | null;
    /** @format int32 */
    organisationId: number;
    /** @format date */
    clinicDate: string;
    responsibleClinicians: string[];
    clinicCode?: string | null;
    location?: string | null;
    /** @format date-time */
    lastUpdated: string;
    /** @format int32 */
    appointmentCount: number;
}

export interface IntegratedClinicResponse {
    name?: string | null;
    /** @format int32 */
    organisationId: number;
    /** @format date */
    clinicDate: string;
    responsibleClinicians: string[];
    clinicCode?: string | null;
    /** @format date-time */
    lastUpdated: string;
    appointments: IntegratedClinicAppointmentResponse[];
}

export interface IntegratedClinicAppointmentResponse {
    /** @format int64 */
    id: number;
    /** @format date-time */
    startTime?: string | null;
    /** @format date */
    dateOfBirth?: string | null;
    nhsNumber?: string | null;
    displayName?: string | null;
    gender?: string | null;
    appointmentType?: string | null;
    hospitalNumber?: string | null;
    location?: string | null;
    patientLookupResult?: PatientLookupStatus | null;
}

export enum PatientLookupStatus {
    Success = "Success",
    PdsLookupFailed = "PdsLookupFailed",
    MissingNhsNumber = "MissingNhsNumber",
    MissingDateOfBirth = "MissingDateOfBirth",
    FailedOther = "FailedOther",
}

export interface StoreAppointmentResult {
    /** @format int64 */
    appointmentId: number;
}

export interface StoreAppointmentRequest {
    /** @format int32 */
    organisationId: number;
    /** @minLength 1 */
    externalId: string;
    /** @format int32 */
    patientId: number;
    /**
     * @format date-time
     * @minLength 1
     */
    startTime: string;
    status?: string | null;
    priority?: string | null;
    consultationMedium?: string | null;
    description?: string | null;
    specialtyCode?: string | null;
    specialtyDisplay?: string | null;
    location?: AppointmentLocationDto | null;
    attendingClinicians?: AppointmentAttendingClinicianDto[] | null;
    healthcareServices?: AppointmentHealthcareServiceDto[] | null;
}

export interface AppointmentLocationDto {
    addressLine?: string | null;
    city?: string | null;
    district?: string | null;
    state?: string | null;
    postalCode?: string | null;
}

export interface AppointmentAttendingClinicianDto {
    idSystem?: string | null;
    id?: string | null;
    title?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export interface AppointmentHealthcareServiceDto {
    idSystem?: string | null;
    id?: string | null;
    display?: string | null;
}

export interface AppointmentSnapshot {
    /** @format int32 */
    organisationId: number;
    /** @format int32 */
    patientId: number;
    /** @format int64 */
    appointmentId: number;
    serviceName: string;
    serviceLocation?: string | null;
    /** @format date-time */
    appointmentTime: string;
    isCancelled: boolean;
    clinician?: string | null;
    appointmentType: string;
}

export interface AppointmentSms {
    selfBookRequest?: SelfBookRequest | null;
}

export interface SelfBookRequest {
    urlId: string;
    status: SelfBookRequestStatus;
    type: SelfBookAppointmentType;
    /** @format date-time */
    expiryDate?: string | null;
    canBeDeclined: boolean;
    /** @format date-time */
    startTime?: string | null;
    location?: string | null;
    /** @format date-time */
    updatedToBookedAt?: string | null;
    slotType: string;
    clinicians?: string[] | null;
}

export enum SelfBookRequestStatus {
    Incomplete = 0,
    Pending = 1,
    Booked = 2,
    Retry = 3,
    Failed = 4,
    Cancelled = 5,
    Expired = 6,
    Declined = 7,
}

export enum SelfBookAppointmentType {
    Telephone = 0,
    FaceToFace = 1,
}

export interface BookingRequestStatus {
    status: SelfBookRequestStatus;
}

export interface SelfBookAvailability {
    /** @format int32 */
    weeksAvailable: number;
    defaultOrgSlotTypesAvailability: SlotTypesAvailability;
    crossOrgAvailableOdsAndNames: Record<string, string>;
    slotTypesWithAvailabilityCount: Record<string, number>;
}

export interface SlotTypesAvailability {
    telephone: Record<string, number>;
    faceToFace: Record<string, number>;
}

export interface SelfBookPatientBookingWork {
    /** @format int32 */
    organisationId?: number | null;
    requestId?: string | null;
    appointmentIds?: string[] | null;
    appointments?: BookableAppointment[] | null;
    patient: PatientExternalIdentityDto;
    bookingNote?: string | null;
}

export interface BookableAppointment {
    id?: string | null;
    /** @format int32 */
    emisSessionId?: number | null;
    /** @minLength 1 */
    slotType: string;
    siteName?: string | null;
    /**
     * @format date-time
     * @minLength 1
     */
    startTime: string;
    clinicians?: string[] | null;
    structuredClinicians?: Clinician[] | null;
    duration?: TimeSpanDto | null;
}

export interface TimeSpanDto {
    /** @format int64 */
    ticks?: number | null;
}

export interface SelfBookPatientBookingWorkResult {
    /** @format int32 */
    accuRxOrgId: number;
    /** @minLength 1 */
    requestId: string;
    appointmentId?: string | null;
    isTerminalFailure?: boolean | null;
    error?: BookingErrorType | null;
}

export enum BookingErrorType {
    None = 0,
    Unknown = 1,
    SlotError = 2,
    PatientError = 3,
    InvalidIdError = 4,
}

export interface SelfBookScrapeWork {
    /** @format int32 */
    organisationId?: number | null;
    requestId?: string | null;
    /** @format date-time */
    from?: string | null;
    /** @format date-time */
    to?: string | null;
    /** @format date-time */
    now?: string | null;
    slotTypes?: string[] | null;
}

export interface SelfBookScrapeBookWorkResult {
    /** @format int32 */
    organisationId: number;
    /** @minLength 1 */
    requestId: string;
    success: boolean;
    /** @format date-time */
    from?: string | null;
    /** @format date-time */
    to?: string | null;
    appointments?: BookableAppointment[] | null;
    sourceSystemType?: PrincipalSystemType | null;
    failedSessionIds?: number[] | null;
}

export interface CreateUserToPatientBookingRequestResponse {
    bookingRequestUrlId: string;
    friendlyErrorMessage: string;
    error?: Errors | null;
}

export enum Errors {
    NoAvailableAppointments = 0,
    Unknown = 1,
    PatientDemographicsMismatch = 2,
}

export interface CreateUserToPatientBookingRequest {
    /** @format int32 */
    organisationId: number;
    /** @format int32 */
    clinicianId: number;
    /** @format int32 */
    patientId: number;
    /** @minLength 1 */
    patientPhoneNumber: string;
    type: SelfBookRequestType;
    slotType?: string | null;
    targetOdsCode?: string | null;
    /** @format int32 */
    contextId?: number | null;
    snomedConceptId?: string | null;
    /** @format date-time */
    expireAt?: string | null;
    declineSettings?: DeclineSettingsData | null;
    specificClinicianEnabled?: boolean | null;
    clinicianGroupIds?: number[] | null;
    availabilityRestriction?: AvailabilityRestriction | null;
}

export enum SelfBookRequestType {
    Telephone = 0,
    FaceToFace = 1,
}

export interface DeclineSettingsData {
    snomedConceptId: string;
    confirmationText: string;
}

export interface AvailabilityRestriction {
    /** @format date-time */
    from: string;
    /** @format date-time */
    to: string;
}

export interface LinkUserToPatientBookingRequestToMessageRequest {
    /** @minLength 1 */
    bookingRequestUrlId: string;
    /** @format int64 */
    userToPatientMessageId: number;
    /** @format int64 */
    patientSmsId?: number | null;
    /** @minLength 1 */
    accurxMessageId: string;
    preferredDeliveryChannel: SelfBookDeliveryChannel;
}

export enum SelfBookDeliveryChannel {
    Sms = 0,
    NhsApp = 1,
    Email = 2,
}

export interface BatchSelfBookStatusSummariesResponse {
    /** @format int32 */
    organisationId: number;
    selfBookCountByStatus: BatchSelfBookStatusSummaryItem[];
}

export interface BatchSelfBookStatusSummaryItem {
    /** @format int32 */
    batchContextId: number;
    /** @format int32 */
    bookedCount: number;
}

export interface BatchSelfBookStatusSummariesRequest {
    /** @format int32 */
    organisationId: number;
    batchContextIds?: number[] | null;
}

export interface CancelBatchUserToPatientBookingRequestsResponse {
    /** @format int32 */
    cancelledCount: number;
}

export interface CancelBatchUserToPatientBookingRequests {
    /** @format int32 */
    organisationId: number;
    /** @format int32 */
    contextId: number;
}

export interface SlotAggregateAvailability {
    slotType: SlotTypeAggregateAvailability[];
    clinicianGroup: ClinicianGroupAggregateAvailability[];
}

export interface SlotTypeAggregateAvailability {
    /** @format int32 */
    id: number;
    name: string;
    /** @format int32 */
    count: number;
}

export interface ClinicianGroupAggregateAvailability {
    /** @format int32 */
    id: number;
    clinicians: ClinicianDetails[];
    /** @format int32 */
    count: number;
}

export interface ClinicianDetails {
    displayName: string;
}
